import type { NearbyOrganizationsResponse } from "./types/nearby-organization";
import type { OfficeListItem } from "./types/office-list-item";

function resolveFranchiseNumber(office: OfficeListItem): number | null {
  const franchiseNumber = office.franchiseNumber ?? office.number;
  if (franchiseNumber == null || franchiseNumber <= 0) {
    return null;
  }
  return franchiseNumber;
}

function mapOfficeRowToNearbyOffice(
  office: OfficeListItem,
  franchiseNumber: number,
) {
  return {
    active: office.active ?? false,
    address: office.address ?? "",
    city: office.city ?? "",
    country: office.country ?? "",
    latitude: office.latitude ?? null,
    longitude: office.longitude ?? null,
    number: office.number ?? franchiseNumber,
    phone: office.phone ?? "",
    postalCode: office.postalCode ?? "",
    stateProvince: office.stateProvince ?? "",
    suite: "",
  };
}

function mapOfficesToOrganizations(
  offices: OfficeListItem[],
): NearbyOrganizationsResponse {
  const officesByFranchise = new Map<number, OfficeListItem[]>();

  for (const office of offices) {
    const franchiseNumber = resolveFranchiseNumber(office);
    if (franchiseNumber == null) {
      continue;
    }

    const franchiseOffices = officesByFranchise.get(franchiseNumber) ?? [];
    franchiseOffices.push(office);
    officesByFranchise.set(franchiseNumber, franchiseOffices);
  }

  const organizations = Array.from(officesByFranchise.entries()).map(
    ([franchiseNumber, franchiseOffices]) => {
      const firstOffice = franchiseOffices[0];

      return {
        active: firstOffice.active ?? false,
        attributes: (firstOffice.attributes ?? []).map((attribute) => ({
          category: attribute.category ?? "",
          number: attribute.number ?? null,
          typeName: attribute.typeName ?? "",
          value: attribute.value ?? "",
        })),
        mappingExclusions: firstOffice.mappingExclusions ?? [],
        number: franchiseNumber,
        offices: franchiseOffices.map((office) =>
          mapOfficeRowToNearbyOffice(office, franchiseNumber),
        ),
        region: firstOffice.region ?? "",
      };
    },
  );

  return { organizations };
}

export { mapOfficesToOrganizations };
